var _mask, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotiBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_7951_4693",
    maskUnits: "userSpaceOnUse",
    x: 2.99707,
    y: 3.33105,
    width: 19,
    height: 21,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 2.99707,
    y: 3.33105,
    width: 19,
    height: 21
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9997 12.4218C19.9997 16.8902 16.4174 20.5126 11.9984 20.5126C11.1176 20.5126 10.2701 20.3687 9.47762 20.1029L5.73727 21.6688L6.87627 18.6377C5.11672 17.1536 3.99707 14.9199 3.99707 12.4218C3.99707 7.95341 7.57938 4.33105 11.9984 4.33105C16.4174 4.33105 19.9997 7.95341 19.9997 12.4218Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9997 12.4218C19.9997 16.8902 16.4174 20.5126 11.9984 20.5126C11.1176 20.5126 10.2701 20.3687 9.47762 20.1029L5.73727 21.6688L6.87627 18.6377C5.11672 17.1536 3.99707 14.9199 3.99707 12.4218C3.99707 7.95341 7.57938 4.33105 11.9984 4.33105C16.4174 4.33105 19.9997 7.95341 19.9997 12.4218Z",
    fill: "#FF0C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47762 20.1029L9.7956 19.1548L9.43869 19.0351L9.09144 19.1805L9.47762 20.1029ZM5.73727 21.6688L4.80118 21.317L3.98612 23.486L6.12345 22.5912L5.73727 21.6688ZM6.87627 18.6377L7.81236 18.9895L8.06073 18.3286L7.52102 17.8733L6.87627 18.6377ZM11.9984 21.5126C16.9801 21.5126 20.9997 17.432 20.9997 12.4218H18.9997C18.9997 16.3484 15.8546 19.5126 11.9984 19.5126V21.5126ZM9.15964 21.051C10.0532 21.3507 11.0081 21.5126 11.9984 21.5126V19.5126C11.2272 19.5126 10.487 19.3867 9.7956 19.1548L9.15964 21.051ZM6.12345 22.5912L9.8638 21.0253L9.09144 19.1805L5.35109 20.7464L6.12345 22.5912ZM5.94019 18.286L4.80118 21.317L6.67336 22.0206L7.81236 18.9895L5.94019 18.286ZM2.99707 12.4218C2.99707 15.2248 4.25461 17.7347 6.23153 19.4021L7.52102 17.8733C5.97884 16.5726 4.99707 14.6151 4.99707 12.4218H2.99707ZM11.9984 3.33105C7.01664 3.33105 2.99707 7.41164 2.99707 12.4218H4.99707C4.99707 8.49518 8.14211 5.33105 11.9984 5.33105V3.33105ZM20.9997 12.4218C20.9997 7.41164 16.9801 3.33105 11.9984 3.33105V5.33105C15.8546 5.33105 18.9997 8.49518 18.9997 12.4218H20.9997Z",
    fill: "white",
    mask: "url(#path-1-outside-1_7951_4693)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6097 8.30004L12.5692 14.5502C12.4565 15.1952 11.5413 15.1895 11.4315 14.5502L10.391 8.30004C10.2417 7.40167 10.8401 6.55027 11.73 6.39793C12.8141 6.19149 13.811 7.20946 13.6111 8.30004H13.6097Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 18.2106C12.6564 18.2106 13.1891 17.6719 13.1891 17.0075C13.1891 16.3431 12.6564 15.8044 11.9993 15.8044C11.3422 15.8044 10.8096 16.3431 10.8096 17.0075C10.8096 17.6719 11.3422 18.2106 11.9993 18.2106Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotiBadge);
export default __webpack_public_path__ + "static/media/noti_badge.98f72a4fc9552049436cfd7cdfa3d4b7.svg";
export { ForwardRef as ReactComponent };